import styled from "styled-components";

export const Styled = styled.div`
  display: flex;
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  .filter-container {
    display: flex;
    gap: 10px;

    .dropdown-options-container {
      z-index: 1000;
    }
  }

  .system-logs-filter {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-left: 6px;

    span {
      color: var(--color-subtle, #7d7e84);
      font-size: 14px;
      line-height: 125%;
    }

    .checkbox {
      margin-top: 5px;
    }
  }

  .date-range-picker__popover {
    z-index: 1000;
  }
`;
